import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/base16/onedark.css';

const Template = () => {

	useEffect(() => {
		hljs.highlightAll();
	}, []);
	
const codice1 = `<!DOCTYPE html>
<html lang="en">
<head>
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1.0">
	<title>Document</title>
</head>
<body>
	<!-- Codice EJS -->
	<!-- E' codice interpetato dal server, il client interpreta solo HTML CSS e JS -->
	BENVENUTO1 <%=variabile1%>
	<br/>
	BENVENUTO2 <%=variabile2.nome%>
</body>
</html>`;

const codice2 = `const express = require('express');
const app = express();
port = 3000;

app.set('views', './views'); //Dove si trovano i template, ovvero in views
app.set('view engine', 'ejs'); //Cosa vogliamo usare, ovvero un engine di tipo ejs

app.get('/', (req,res) => {
    let dati = "mario rossi"

    let persona={
        nome:"Mario",
        cognome:"Rossi",
        eta:47,
        cf:"GLRTAUC0246S",

    }

    //Funzione render, si trova all'interno di res. Prendo i dati, invia i dati al template, costruisce la pagina e invia la pagina al client
    //Render vs sendFile --> sendFile prende la pagina così com'è e invia al client mentre render inserisce anche il parametro
    res.render("index",{
        //Object literal, chiave valore
        variabile1:dati,
        variabile2:persona
    });

});

app.listen(port,()=>{

});`;

const codice3 = `npm install ejs`;

  return (
    <div className="container-fluid">
    	<div className="div-intro mb-5">
			<div data-aos="fade-right">
			<h1>Template Engine</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
			<br/>
			<div data-aos="fade-right">
			<h4>Template Engine e il loro utilizzo</h4>
			<p>
I <strong>template engine</strong> in Node.js sono strumenti che semplificano la generazione dinamica di contenuti HTML lato server. Consentono di incorporare dati dinamici nei template HTML in modo da poterli visualizzare dinamicamente nella risposta inviata al browser. Non è lato client perché si collega al db, carica i dati nell'html creando una pagina live e lo spedisce al client. Alcuni template engine popolari in Node.js includono EJS (Embedded JavaScript), Handlebars, Pug (precedentemente noto come Jade), Nunjucks, e molti altri. Ogni template engine ha la sua sintassi e caratteristiche specifiche, ma il concetto di base rimane lo stesso.</p>
			</div>
			<div id="ejs"></div>
			<br/><br/>
			<br/>
			<div data-aos="fade-right">
			<h1>EJS</h1>
			<hr className="underline" data-aos="fade-right"/>
			</div>
<p data-aos="fade-right"><strong>EJS</strong> (<i>Embedded JavaScript</i>) è un motore di template per Node.js e JavaScript in generale. Consente di incorporare del codice JavaScript all'interno dei file di template HTML per renderli dinamici. EJS è facile da usare e leggere, ed è una scelta popolare per creare pagine web dinamiche con Node.js e Express. I file hanno come estensione .ejs .</p><br/>
<p data-aos="fade-right">Per installare EJS bisogna eseguire il seguente comando:</p>
<div data-aos="zoom-in">
<pre className="outside-code-toolbar">
<code className="language-json inside-code-toolbar">
{codice3}
</code></pre>
</div>
<br/>
<div data-aos="fade-right">
<h4>Progetto Template Engine EJS (<a href="Progetto_10_TemplateEngine.zip" target="_blank" download>scarica qui <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-cloud-arrow-down-fill" viewBox="0 0 16 16">
  <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708"/>
</svg></a>)</h4>
<p>Ecco un progetto contentente un esempio di utilizzo di EJS:</p>
</div>
<div data-aos="zoom-in">
<i>index.ejs (si deve trovare all'interno della cartella views)</i>
<pre className="outside-code-toolbar">
<code className="language-html inside-code-toolbar">
{codice1}
</code></pre>
</div>
<div data-aos="zoom-in"><i>server.js</i>
<pre className="outside-code-toolbar">
<code className="language-javascript inside-code-toolbar">
{codice2}
</code></pre></div>
		</div>
    </div>
  );
};

export default Template;
